import React from "react";
import {
  useHistory,
} from "react-router-dom";

import MiddleLayout from '../layouts/MiddleLayout'

const NoMatch = () => {
  const history = useHistory();

  return (
    <MiddleLayout>
      <main className="bg-white relative relative p-10 shadow-lg rounded-3xl">
        <div className="container mx-auto pt-32 md:pt-0 px-6 z-10 flex items-center justify-between">
          <div className="container mx-auto px-6 flex flex-col-reverse lg:flex-row justify-between items-center relative">
            <div className="w-full mb-16 md:mb-8 text-center lg:text-left">
              <h1 className="font-light font-sans text-center lg:text-left text-5xl lg:text-8xl mt-12 md:mt-0 text-gray-700">
                Désolé cette page n'est pas disponible
              </h1>
              <button
                className="px-2 py-2 w-36 mt-16 text-white hover:bg-blue-700 rounded-lg focus:ring-offset-blue-200 bg-blue-600 focus:outline-none focus:ring-offset-blue-200 transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2"
                onClick={() => history.goBack()}
              >
                Retour
              </button>
            </div>
            <div className="block w-full mx-auto md:mt-0 relative max-w-md lg:max-w-2xl">
              <img src="/assets/404.svg" alt='en cours de construction'/>
            </div>
          </div>
        </div>
      </main>
    </MiddleLayout>
  );
}

export default NoMatch